import { rankCol, playerCol, divCol, teamCol, teamNameCol, confCol, yearCol, numCol, pctCol } from "./helpers";

const battedBallStats = [
  numCol("BB", "batted_balls"),
  pctCol("Pull%", "pull_pct"),
  pctCol("Middle%", "middle_pct"),
  pctCol("Oppo%", "oppo_pct"),
  pctCol("GB%", "gb_pct"),
  pctCol("LD%", "ld_pct"),
  pctCol("FB%", "fb_pct"),
  pctCol("PU%", "pu_pct"),
  { ...numCol("FB/GB", "fb_per_gb"), cell: (row) => row.fb_per_gb != null ? Number(row.fb_per_gb).toFixed(2) : "—" },
  pctCol("HR/FB", "hr_per_fb"),
  pctCol("Pull Air%", "pull_air_pct", "7rem"),
  pctCol("Oppo GB%", "oppo_gb_pct", "7rem"),
];

export const columnsBattedBallBatter = [
  rankCol(),
  playerCol(),
  teamCol(),
  confCol(),
  divCol(),
  yearCol(),
  { name: "Bats", selector: (row) => row.hand, sortable: true, cell: (row) => row.hand != null ? row.hand.charAt(0).toUpperCase() : "—", width: "4.5rem", className: "text-center" },
  ...battedBallStats,
];

export const columnsBattedBallPitcher = [
  rankCol(),
  playerCol(),
  teamCol(),
  confCol(),
  divCol(),
  yearCol(),
  { name: "Throws", selector: (row) => row.hand, sortable: true, width: "5rem", className: "text-center" },
  ...battedBallStats,
];

export const columnsBattedBallBattingTeam = [
  rankCol(), teamNameCol(), divCol(), confCol(), yearCol(),
  ...battedBallStats,
];

export const columnsBattedBallPitchingTeam = [
  rankCol(), teamNameCol(), divCol(), confCol(), yearCol(),
  ...battedBallStats,
];
